import { useQuery, queryOptions } from '@tanstack/react-query';

import { get } from '@/libs/http';

export const getLogout = () => {
  return get<null>('/user/auth/v1/logout');
};

export const getLogoutQueryOptions = () => {
  return queryOptions({
    queryKey: ['logout'],
    queryFn: () => getLogout(),
  });
};

export const useLogout = () => {
  return useQuery({
    ...getLogoutQueryOptions(),
  });
};